<template>
  <c-view>
    <c-page>
      <c-content class="page_content">
        <div class="christmax__box">
          <transition name="fade">
            <swiper id="swiperBox"
                    v-bind:options="swiperOption"
                    ref="mySwiper">
              <!-- 第一页 -->
              <swiper-slide class="swiper-slide1">
                <div class="christmax__box__img1 imgbox">
                  <div class="arrow"
                       @click="goToNext(1)">
                    <img src="../../assets/images/christmax/bottom__arrow.gif"
                         alt=""
                         class="bottom__arrow">
                  </div>
                </div>

              </swiper-slide>
              <!-- 第二页 -->
              <swiper-slide class="swiper-slide2">
                <swiper id="swiperBox1"
                        v-bind:options="swiperimg2Option"
                        ref="mySwiper2">
                  <!-- 第一页 -->
                  <swiper-slide class="swiper-slider">
                    <div class="title">
                      <img src="../../assets/images/christmax/title.png"
                           alt=""
                           class="title">
                    </div>
                    <div class="img1__box">
                      <!-- <img src="../../assets/images/christmax/image2__banner1.png"
                           alt=""
                           style="width:100%;top:0;left:0;right:0;bottom:0;margin-bottom:130px;height:80%"> -->
                      <div class="right__arrow"
                           @click="goToPre(1)">
                      </div>
                    </div>
                  </swiper-slide>
                  <!-- 第二页 -->
                  <swiper-slide class="swiper-slider">
                    <div class="title">
                      <img src="../../assets/images/christmax/title.png"
                           alt=""
                           class="title">
                    </div>
                    <div class="img2__box">
                      <div class="left__arrow"
                           @click="goToPre(0)">
                      </div>
                      <div class="right__arrow"
                           @click="goToPre(2)">
                      </div>
                    </div>
                  </swiper-slide>
                  <!-- 第三页 -->
                  <swiper-slide class="swiper-slider">
                    <div class="title">
                      <img src="../../assets/images/christmax/title.png"
                           alt=""
                           class="title">
                    </div>
                    <div class="img3__box">
                      <div class="left__arrow"
                           @click="goToPre(1)">
                      </div>
                    </div>
                  </swiper-slide>
                </swiper>
                <div class="arrow__next"
                     @click="goToNext(2)">
                  <img src="../../assets/images/christmax/bottom__arrow.gif"
                       alt=""
                       class="bottom__arrow">
                </div>
                <!-- <div class="bottom__btn"></div> -->
                <!-- <div class="christmax__box__img2 imgbox">
                  <div class="bottom__btn"></div>
                </div> -->
                <!-- <div class="bottom__btn"></div> -->
              </swiper-slide>
              <!-- 第三页 -->
              <swiper-slide class="swiper-slide3">
                <div class="christmax__box__img3 imgbox">
                  <!-- <div class="bottom__btn"></div> -->
                </div>
              </swiper-slide>
            </swiper>
          </transition>

        </div>
      </c-content>
      <c-footer>
        <c-button class="bottom__btn"
                  @click.native="showDialog">

        </c-button>
      </c-footer>
      <div class="serve">
        <img src="../../assets/images/christmax/serve.png"
             alt="">
        <span>4001683399</span>
      </div>
      <div class="van-overlay"
           style="z-index: 10;"
           @click="dialogVisible = false"
           v-show="dialogVisible"></div>
      <div role="dialog"
           v-show="dialogVisible"
           class="van-dialog"
           style="z-index: 11;">
        <div class="van-dialog__content">
          <img src="../../assets/images/2019-11-11/pre-sale/close-btn.png"
               class="close-btn"
               @click="dialogVisible = false"
               alt="">
          <div style="position:relative;">
            <img src="../../assets/images/christmax/dialog.png"
                 class="cover"
                 alt="">
            <div class="weui-cell__bd">
              <input class="weui-input"
                     type="tel"
                     placeholder="请输入手机号"
                     v-model="phone">
              <a href="javascript:void(0);"
                 class="get-now"
                 @click.stop="handleDialogClick"></a>
            </div>
          </div>
        </div>
      </div>
    </c-page>
  </c-view>
</template>
<style lang="scss" scoped>
// @import 'swiper/dist/css/swiper.css';
@import './index';
</style>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import regs from '../../tools/regs.js'
export default {
  data () {
    return {
      swiperOption: {
        // swiper configs 所有的配置同swiper官方api配置
        notNextTick: true, // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: 'vertical', // 水平方向移动
        grabCursor: true, // 鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, // Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, // 自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, // 设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: false, // 开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: false, // 同上
        height: window.innerHeight, // 高度设置，占满设备高度
        resistanceRatio: 0, // 抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, // 将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新
        speed: 1000,
        initialSlide: 0,
        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        debugger: true
        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
      },
      swiperimg2Option: {
        notNextTick: true, // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: 'horizontal', // 水平方向移动
        grabCursor: true, // 鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, // Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, // 自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, // 设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: false, // 开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: false, // 同上
        height: window.innerHeight, // 高度设置，占满设备高度
        resistanceRatio: 0, // 抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, // 将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新
        speed: 700,
        initialSlide: 0,
        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        debugger: true
      },
      dialogVisible: false,
      phone: '',
      banners: [
        '../../assets/images/christmax/image2__banner1.png',
        '../../assets/images/christmax/image2__banner2.png',
        '../../assets/images/christmax/image2__banner3.png'
      ]
    }
  },
  components: { swiper, swiperSlide },
  created () {
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    },
    swiper2 () {
      return this.$refs.mySwiper2.swiper
    }
  },
  methods: {
    goToNext (value) {
      this.swiper.slideTo(value, 1000, false)
    },
    goToPre (value) {
      this.swiper2.slideTo(value, 1000, false)
    },
    showDialog () {
      this.dialogVisible = true
    },
    handleDialogClick () {
      if (!this.phone) {
        this.$wejs.alert(regs.phone.nil)
        return
      }
      if (!regs.phone.reg.test(this.phone)) {
        this.$wejs.alert(regs.phone.msg)
        return
      }
      this.dialogVisible = false
      this.phone = ''
      this.$wejs.alert('领取成功')
    }
  },
  mounted () {
  },
  events: {}
}
</script>



// WEBPACK FOOTER //
// index.vue?21299736